module.exports = __webpack_public_path__ + "img/eestec.c3dab355.png";